/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangeLog } from '../../models/change-log';

export interface ServerStatusControllerGetMigrations$Params {
}

export function serverStatusControllerGetMigrations(http: HttpClient, rootUrl: string, params?: ServerStatusControllerGetMigrations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ChangeLog>>> {
  const rb = new RequestBuilder(rootUrl, serverStatusControllerGetMigrations.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ChangeLog>>;
    })
  );
}

serverStatusControllerGetMigrations.PATH = '/server-status/migrations';
